import React, { Fragment, useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import MainFooter from '../nav/MainFooter';
import TopNav from '../nav/TopNav';
import ApparelNav from './ApparelNav';
import PropTypes from 'prop-types';
import ApparelContext from '../../context/apparel/apparelContext';
import TeesItem from './TeesItem';
import './ApparelProductPage.style.css';

const Product = ({ buttonSizes }) => {
  const apparelContext = useContext(ApparelContext);

  // destructuring the ApparelContext
  const { products } = apparelContext;

  return (
    <Fragment>
      <Container fluid className='ApparelCollections'>
        <TopNav />
        <Container>
          <ApparelNav />
          <div className='spacer'></div>
          <Row className=' my-4'>
            <Col xl={8} className='product_imgs'>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </Col>
            <Col md={4} className='text-light'>
              <div>
                <div className='TeesItem_heading pr-5'>
                  Instinct Vol. 5 Mosaic Crewneck Sweater
                </div>
                <div>₹ 3,418.00</div>
              </div>
              <div>
                <div className='TeesItem_heading my-2'>size</div>
                <div className=''>
                  <button className={buttonSizes}>xs</button>
                  <button className={buttonSizes}>s</button>
                  <button className={buttonSizes}>m</button>
                  <button className={buttonSizes}>l</button>
                  <button className={buttonSizes}>xl</button>
                  <button className={buttonSizes}>xxl</button>
                </div>
                <div>
                  <button className='btn border border-light my-2 text-light'>
                    whats my size?
                  </button>
                </div>
              </div>
              <div>
                <div className='TeesItem_heading'>color</div>
                <div className='product_Item_colors'>
                  <span></span>
                  <span></span>
                </div>
              </div>
              <div>
                <div className='TeesItem_heading'>quantity</div>
                <button className='btn border border-light text-light'>
                  - num +
                </button>
              </div>
              <div className='my-3'>
                <button className='btn btn-theam'>add cart</button>
              </div>
              <div className='TeesItem_para my-5'>
                <p className='TeesItem_heading'>Details</p>
                <p className='TeesItem_para'>
                  Made from our premium french terry fabric, it features our
                  signature Monstercat pinch tag.
                </p>
                <p className='TeesItem_para'>
                  66% Cotton, 27% Polyester, 7% Spandex
                </p>
              </div>
              <div className='mt-4'>
                <p className='TeesItem_heading'>Care & instructions</p>
                <p className='TeesItem_para m-0'>
                  Reverse garment before washing or ironing Machine wash cold,
                  gentle cycle with like colours
                </p>
                <p className='TeesItem_para m-0'>No bleach </p>
                <p className='TeesItem_para m-0'>Tumble dry low - low iron </p>
                <p className='TeesItem_para m-0'>Do not iron decoration </p>
                <p className='TeesItem_para m-0'>Do not dry clean</p>
              </div>
            </Col>
          </Row>

          <h3 className='text-light'>You may also like</h3>
          <div className='tees_items'>
            {products.map((product) => (
              <TeesItem key={product.id} tee={product} />
            ))}
          </div>
        </Container>
      </Container>
      <MainFooter />
    </Fragment>
  );
};

Product.defaultProps = {
  buttonSizes: 'btn btn-black mr-1 text-uppercase',
};

Product.propTypes = {
  buttonSizes: PropTypes.string.isRequired,
};
export default Product;
